import { render, staticRenderFns } from "./projectSettings.vue?vue&type=template&id=af2420d2&scoped=true&"
import script from "./projectSettings.vue?vue&type=script&lang=js&"
export * from "./projectSettings.vue?vue&type=script&lang=js&"
import style0 from "./projectSettings.vue?vue&type=style&index=0&id=af2420d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2420d2",
  null
  
)

export default component.exports